import React from 'react'
import {sortBy} from 'lodash/fp'
import {getYear} from 'date-fns' 

import CourseCalendarQuarterList from '../course-calendar-quarter-list'

class CourseCalenderByYear extends React.Component {
  render(){
    let {courseSchedule} = this.props 
    courseSchedule = courseSchedule || []
    let scheduleSortedByYear = courseSchedule.reduce((result, course) => {
      let year = getYear(course.startDate)
      result[year] = result[year] || []
      result[year].push(course)
      return result
    }, {})
    let years = Object.keys(scheduleSortedByYear).sort()
    return (
      <div className='course-calender-year-list' >
        {years.map((year, i) => 
          <div key={i} className='course-calendar-year' >
            <CourseCalendarQuarterList 
              year={year} 
              courseSchedule={scheduleSortedByYear[year]} 
              designateLocation={this.props.designateLocation}
              />
          </div>
        )}
      </div>
    )
  }
}

export default CourseCalenderByYear



// WEBPACK FOOTER //
// ./src/components/course-calendar-year/index.js